import { list_users } from "@/graphql/queries";
import { generateClient } from "aws-amplify/api";
const client = generateClient();

export const GetAllListUsers = {
  data: () => ({
    ListAllMembers: [],
  }),
  methods: {
    async GetAllListUsersMethod(organization_id) {
      try {
        let result = await client.graphql({
          query: list_users,
          variables: {
            organization_id: organization_id,
            user_status: this.selected_status,
            user_type: "MEMBER",
            name_search: this.search,
            limit: 100,
            nextToken: null,
          },
        });
        console.log("Result", result);
        let response = result.data.list_users;
        if (response && response.details) {
          this.ListAllMembers = response.details;
        }
      } catch (error) {
        this.ListAllMembers = [];
        console.log("Error", error);
      }
    },
  },
};